import { BaseRequest } from './BaseRequest';

export class UpdateIncidentDescriptionRequest extends BaseRequest {
    IncidentId: string;
    Description: string;
    IncidentUpdateId: string;
}